import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants';
import { View } from 'backbone';
import { Model } from 'backbone';
import pageCollection from 'PageCollection'
import pageSyncService from 'PageSyncService';
import listService from 'ListService';
import pageCaptureController from 'PageCaptureController';
import ThumbPageView from 'designer/ThumbPageItemView';
import template from 'designer/left-panel.ejs';

import Spinner from 'spin/spin';
import eventBus from 'EventBus';

import undoService from 'UndoService.js';
import formService from 'FormService.js';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import util from 'util/Util.js';
import BreadCrumbView from 'BreadCrumbView.js';
import viewManagerService from 'ViewManagerService';

import leftPanelState from "LeftPanelStateService";
import FilterAndSearchView from './FilterAndSearchView';
import StateAndMandatoryView from './StateAndMandatoryView';
import ThumbPageBehaviorsOnlyView from './ThumbPageBehaviorsOnlyView';
import notificationService from '../../service/NotificationService';

const SILENT = constants.MODEL_SILENT;

//=========================================================
// This is a view on a collection of per-page control items
//=========================================================
class ThumbPageListView extends View {
    initialize(opts) {
        this.options = opts || {};

        this.tagName = 'div';
        this.id = opts.el;
        this.selectedType = '';

        const self = this;

        this.model.set('isForm', listService.docType === constants.DOC_TYPE_FORM, SILENT);
        this.model.set('sectionTitle', listService.docType === constants.DOC_TYPE_FORM ? "App" : 'Report', SILENT);

        this.events = {
            'click  .document-heading': 'thumbnailClickListener',
            'click  #addpage': 'clickOnAddPage',
            'click .document .switch, #right-rail .switch': 'toggleIcon',
            'click #expcol': 'expandAllItems',
            'click #collcol': 'collapseAllItems',
            'click #document-1 .document-type-show': 'switchIcon',
            'click #document-filter .document-heading, #document-state .document-heading, #document-1  .document-heading': 'toggleIcon'
        };

        // this.searchableItems = listService.getSearchableItems();
        this.searchableItems = [];
        this.collection = pageCollection;
        //        this.collection.comparator = 'timestamp';
        this.model.set('helpUrl', constants.HELP_GENERAL_URL);

        // Need this for when we switch layouts.
        if (!listService.loading) {
            this.establishPageListener();
        }

        this.formLoadCompleted = () => {
            this.establishPageListener();
        };

        // Wait for form to finish loading, then render
        this.listenTo(eventBus, constants.EV_FORM_LOADED, this.formLoadCompleted);
        this.listenTo(eventBus, constants.EV_ROLE_OR_STAGE_UPDATED, this.updateStageAndRoles );
        this.listenTo(eventBus, constants.EV_SELECT_OBJECT, this.selectObject);
        this.listenTo(eventBus, constants.EV_DELETE_TREE_FILTER, this.refreshFilterTree);
        this.listenTo(eventBus, constants.EV_UPDATE_BEHAVIORS_ONLY, this.openBehaviorsOnly);
        this.listenTo(eventBus, constants.EV_OPEN_PAGE, this.thumbnailClickListener);
        
      
        $(document).on(constants.EV_PAGE_OBJECTS_UPDATED, this.updatePageObjects.bind(this));
        $(document).on(constants.EV_PAGE_COMMANDS_UPDATED, this.updatePageCommands.bind(this));
        $(document).on(constants.EV_PAGE_DELETE_CURRENT, this.pageDeleteCurrent.bind(this));

      
        return this;
    }

    initBreadcrumb() {
        this.breadCrumbView = new BreadCrumbView({
            //mode:this.model.get('mode'),
            mode: listService.mainKind,
            el: this.$el.find('.left-breadcrumb')
        });

        viewManagerService.renderBreadcrumbView(this.breadCrumbView, true);
    }

    switchIcon(e) {
        let icon = $("a[data-target='#well0'] i");

        if (icon) {
            icon.toggleClass('pf-carot-left pf-carot-down');
        }
    }

    toggleIcon(e, rotate) {
        util.toggleIcon(e,rotate);
    }    

    expandAllItems(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        let collapsibleIcons = $(".document-group .document-heading > .switch > i");
        let collapsibleDocuments = $(".document-group .document-body");
        let documentTitle = $('.document-group .document-heading');
        let addIconClass = "pf-carot-down";
        let removeIconClass = "pf-carot-left";
        let pageNodeId, pageTreeItemDiv;

        for (var i = 0, len = collapsibleIcons.length; i < len; i++){ //Load all nodes that are not loaded yet
            pageTreeItemDiv = $(collapsibleIcons[i]).parents('.document')[0];
            pageNodeId = $(pageTreeItemDiv).attr('id');
            if (pageNodeId && pageNodeId.indexOf('tn-pg-') > -1){
                thumbPageListUtil.loadTreeNodesByPageId(pageNodeId.split('tn-pg-')[1]);
            }
        }
        collapsibleDocuments.collapse('show');
        collapsibleIcons.removeClass(removeIconClass)
            .addClass(addIconClass);
        documentTitle.addClass('expanded-page');
        documentTitle.removeClass('collapsed-page');
        LeftPanelStateService.savePages();        
    }

    collapseAllItems(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        let collapsibleIcons = $(".document-group .document-heading > .switch > i");
        let collapsibleDocuments = $(".document-group .document-body");
        let documentTitle = $('.document-group .document-heading');
        let addIconClass = "pf-carot-left";
        let removeIconClass = "pf-carot-down";

        collapsibleDocuments.collapse('hide');
        collapsibleIcons.removeClass(removeIconClass)
            .addClass(addIconClass);
        documentTitle.removeClass('expanded-page');
        documentTitle.addClass('collapsed-page');
        LeftPanelStateService.savePages();
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();

        $('li.object-selector').off();
        $('li.behavior-selector').off();
        //        $('#searchLeftPanel').typeahead('destroy').unbind();

       // $("#dropBag").sortable('destroy').off();
        //$("#dropBag li span").remove();

        $("#thumb-pages").sortable('destroy');
        $("#thumb-pages li span").remove();

        $(document).off(constants.EV_PAGES_UPDATED, this.pageListener);
        $(document).off(constants.EV_FORM_LOADED, this.formLoadCompleted);

        $(document).off(constants.EV_PAGE_OBJECTS_UPDATED);
        $(document).off(constants.EV_PAGE_COMMANDS_UPDATED);
        $(document).off(constants.EV_PAGE_DELETE_CURRENT);

        this.$el.empty();

        super.remove();
    }

    establishPageListener() {
        this.pageListener = (options) => {
       
            const evt = options.evt || "UPDATE";

            if (evt !== "DELETE") {

                let index = this.collection.length - 1
                if(options.pageIndex || options.pageIndex === 0){
                    index = options.pageIndex;
                }
                
                const newPageModel = this.collection.models[index]

                if (!newPageModel.get("rendered") || options.undo) {
                    const newPage = new ThumbPageView({ model: newPageModel, el: constants.THUMBPAGES_ID, undo: options.undo }).render()
                    const newPageBO = new ThumbPageBehaviorsOnlyView({ model: newPageModel, el: constants.THUMBPAGESBO_ID, undo: options.undo }).render()
                    newPageModel.set("rendered", true, { silent: true });
                }
            }
            else{
                const deletedPage = $("#thumb-pages").find(`div[id*='${options.pageId}']`);
                deletedPage.remove();
            }

            leftPanelState.save();            
        };
        this.listenTo(eventBus, constants.EV_PAGES_UPDATED, this.pageListener);
    }

    //============================================================================
    // Remove page from BB collection of pages used to render thumbnails
    //============================================================================
    pageDeleteCurrent() {
        const pageId = listService.currentPageId;
        if (pageId) {
            const model = this.collection.get(pageId);
            this.collection.remove(model);
        }
    }
 
    refreshFilterTree() {
        leftPanelState.save();
        leftPanelState.restore(true);
        this.openBehaviorsOnly();
    }

    selectObject(id) {
       thumbPageListUtil.selectObject(id);
    }  

    updatePageObjects(ev, type, objectType, id, name, page, group) {
        const $collapseSwitch = $('#well' + page + ' a[data-target="#objects-page-' + page + '"].switch'),
            self = this,
            instance = listService.getBehaviorInstance(group);

        if (objectType === 'object') {
            eventBus.trigger(constants.EV_VALIDATE_PULSE_ICON_EVENT);
            if (type === 'add') {
                const _newObj = listService.getObject(id);
                const pg = listService.getPage(page);
                const liToAppend = _newObj._groupId ? $("li[data-id='" + _newObj._groupId + "'] > div > ul")
                    : $('#objects-page-' + page + ' > ul');

                let objHTML = thumbPageListUtil.addObjectToNavigationTree(_newObj, pg.id, true);
                liToAppend.append(objHTML);

                thumbPageListUtil.addSelectorEvents();

                //  Expand the tree on each added object
                $('.page-selected').removeClass('page-selected');
                let selectedPage = $(`#tn-pg-${page}`)[0].querySelector('div.document-heading');
                $(selectedPage).addClass('page-selected').addClass('expanded-page').removeClass('collapsed-page');
                const $well = util.jqId(`well${page}`);
                $well.collapse('show');
                const pageSwitch = $('a[data-target="#well' + page + '"] i');
                pageSwitch.removeClass('pf-carot-left').addClass('pf-carot-down');
                const pageTitle = $('a[data-target="#well' + page + '"] i');
                pageSwitch.removeClass('pf-carot-left').addClass('pf-carot-down');

                if (_newObj._groupId) {
                    let parent = listService.getObject(_newObj._groupId);
                    thumbPageListUtil.expandControlParent(parent);
                }


                if (pg) {
                    this.addSearchableItem('object', id, name, pg.model.get('name') + '/' + name, pg.model.get('name'), pg.model.get('name'), _newObj._groupId ? listService.getObjectName(_newObj._groupId) : '');
                    pageSyncService.addItemToPageCollection({ name: name, link: '', id: id }, pg, objectType);
                    //Updating object's array
                    let filteredPage = this.collection.filter(p => p.get('id') === pg.model.get('id'));
                    //TODO - Page model lose objects list when reopening form and adding a new control to the page, that's why we need to 'fix' this at this point
                    //but we need to find the root cause of this behavior and solve it there instead of fixing it here.
                    const objectsOnPage = listService.getPageControls(pg.model.get('id'));
                    if (objectsOnPage.size !== pg.model.get('objects').length) {
                        const _updatedObjects = [...objectsOnPage.values()];
                        pg.model.set('objects', _updatedObjects, { silent: true });
                    }

                    filteredPage[0].set('objects', pg.model.get('objects'), { silent: true });
                    filteredPage[0].set('objectCount', pg.model.get('objectCount'), { silent: true });
                }
            } else { // no add, so delete or update
                const childElements = $("#objects-page-" + page + " ul li[data-id='" + id + "'] ul").first().children('li');
                if (childElements.length > 0) {
                    const parent = $("#objects-page-" + page + " ul li[data-id='" + id + "']").parent();
                    let isUndo = false;
                    $.each(childElements, (idx, childElement) => { //Check if child elements still exist, if true then it is an undo operation
                        if ($(childElement).data('id') && listService.getObject($(childElement).data('id'))) {
                            isUndo = true;
                            return;
                        }
                    });
                    if (isUndo) {
                        parent.append(childElements);
                    }
                }

                let obj = $('#objects-page-' + page + ' ul li[data-id="' + id + '"]');
                // must detect that it existed under the Page - Objects.
                if (obj) {
                    $(obj).remove();
                    this.removeSearchableItem(id);
                    const pg = listService.getPage(page);
                    pageSyncService.removeItemFromPageCollection(id, pg, objectType);
                    //Updating behaviors's array
                    let filteredPage = this.collection.filter(p => p.get('id') === pg.model.get('id'));
                    filteredPage[0].set('behaviors', pg.model.get('behaviors'), { silent: true });
                    filteredPage[0].set('behaviorCount', pg.model.get('behaviorCount'), { silent: true });
                }
                thumbPageListUtil.addSelectorEvents();
            }

        } else { // no control, so behavior
            if (type === 'add') {
                if (instance.get('owner') === 'Form') {
                    $('#behaviors-forms ul').append('<li class="behavior-selector" data-id="' + id + '"><a>' + name + '</a></li>');
                } else {
                    $('#behaviors-page-' + page + ' ul').append('<li class="behavior-selector" data-id="' + id + '"><a>' + name + '</a></li>');
                }

                const pg = listService.getPage(page);
                if (instance.get('owner') === 'Form') {
                    this.addSearchableItem('behaviors', id, name, 'Form/' + name);
                } else {
                    this.addSearchableItem('behaviors', id, name, pg.model.get('name') + '/' + name);
                }

                //Checking is a form behavior
                if (instance.get('owner') === 'Form') {
                    this.addItemToFormCollection({ name: name, link: '', id: id }, objectType);
                } else {
                    pageSyncService.addItemToPageCollection({ name: name, link: '', id: id }, pg, objectType);
                }

            } else if (type === 'update') { // no add, so update
                let element = $('.behavior-options [data-id="' + id + '"] a');
                if (element.length > 0) {
                    element[0].innerText = name;
                } else {
                    let instance = listService.getBehaviorInstance(id);
                    let owner = instance.get('ownerId'), behaviorKey = instance.get('behaviorKey');
                    element = $('[data-objectid="' + owner + '"][data-behaviorkey="' + behaviorKey + '"] a');
                    if (element.length > 0) {
                        element[0].innerText = name;
                    }
                }
            } else { // no add, no update, so delete
                var obj = $('#behaviors-page-' + page + ' ul li[data-id="' + id + '"]');
                // must detect that it existed under the Page - Objects.
                if (obj) {
                    $(obj).remove();
                    this.removeSearchableItem(id);
                    const pg = listService.getPage(page);
                    pageSyncService.removeItemFromPageCollection(id, pg, objectType)
                }
            }

            // and, after mofify the tree, add listener
            $('li.behavior-selector').off('click').on('click', (ev) => {
                leftPanelState.save();
                let id = ev.currentTarget.attributes["data-id"].value,
                    objId = ev.currentTarget.attributes["data-objectid"].value,
                    behaviorKey = ev.currentTarget.attributes["data-behaviorkey"].value;
                thumbPageListUtil.selectBehaviorInstance(id, '', objId, behaviorKey);
            });

        }

        //thumbPageListUtil.updateBehaviorsOnly();
    }

    updatePageCommands(ev, type, objectType, id, name, page, instanceId) {
        if (type === 'add') {
            this.addSearchableItem(objectType, id, name, page + '/' + name, instanceId);
        } else {
            this.removeSearchableItem(id);
        }
    }

    clickOnAddPage(ev) {
        formService.addPage();
        eventBus.trigger('selectPage');       

        if($("#behaviorsonly-tab").hasClass("active")){
            //notificationService.info('A new page is added, please select “All Objects” on the Navigation Panel to view or navigate to the page.');
            $("#allobjects-tab a").trigger("click");
        }
    }

    setUndoRedoAccess() {
        $('#designerUndo').removeClass('disabled pf-disable');
        $('#designerRedo').removeClass('disabled pf-disable');

        if (!undoService.hasUndo()) {
            $('#designerUndo').addClass('disabled pf-disable');
        }

        if (!undoService.hasRedo()) {
            $('#designerRedo').addClass('disabled pf-disable');
        }

    }

    //========================================================================================================
    // 1. Identify page DOM ID corresponding to the clicked thumbnail.
    // 2. Clear the selected thumbnail by clearing selection of all of thumbnails.
    // 3. Select the clicked thumbnail.
    // 4. Call service to remove visible DOM controls, then populate layout with controls of chosen page.
    //========================================================================================================
    thumbnailClickListener(evt, force) {
        // PF-3995: Let the event fall through and skip all code below
        if (evt.target &&
            (evt.target.tagName === 'A' && $(evt.target).hasClass('switch')) ||
            ($(evt.target).hasClass('not-page') || $(evt.target).parents().hasClass('not-page'))
        ) {
            return;
        }

        //PF-5906 - Check if the page does have its objects loaded in the tree, if not then load them
        if (evt.target && (['A', 'I', 'H4'].indexOf(evt.target.tagName) > -1 || $(evt.target).hasClass('document-heading'))){ //Catch click on arrow and on page node
            const pageTreeItemDiv = $(evt.target).parents('.document')[0];
            const pageNodeId = pageTreeItemDiv ? $(pageTreeItemDiv).attr('id') : undefined;
            if (pageNodeId && pageNodeId.indexOf('tn-pg-') > -1){
               thumbPageListUtil.loadTreeNodesByPageId(pageNodeId.split('tn-pg-')[1]);
            }
            else{
                if (pageNodeId && pageNodeId.indexOf('bo-pg-') > -1){//Behaviors only
                    const page = listService.getPage(pageNodeId.split('bo-pg-')[1]);

                    const hasBehaviors = $("#" + pageNodeId).find("ul li").length > 0;
                    if(!page.model.get("behaviorsLoaded") || !hasBehaviors){
                        //thumbPageListUtil.updateBehaviorsOnly(page.model, false);
                        leftPanelState.save();       
                    }
                     
                    thumbPageListUtil.addSelectorEvents(); 
                } 
            }

            if (evt.target.tagName === 'I'){
                return;
            }
        }

        let localForce = false;


        // 1. Identify the thumbnail container for this page group.
        //   - Either the empty div parent suffered the click, or the injected child canvas got the click
        //   - We accept the canvas as being optional; it may not have yet been captured from a page.
        //   - We used that parent DIV's IDto get its data-page attribute
        var clickedId = evt.target.id ? evt.target.id : evt.target.parentElement.id;
        var selectedElement = evt.target;

        if (evt.target.id) {
            clickedId = evt.target.id;
            selectedElement = evt.target.parentElement;
        } else if (evt.target.classList.contains('document-heading')) {
            clickedId = evt.target.children[1].id;
            selectedElement = evt.target;
        } else if (evt.target.parentElement.parentElement.children[1]) {
            clickedId = evt.target.parentElement.parentElement.children[1].id;
            selectedElement = evt.target.parentElement.parentElement;
            // PF-2353: to prevent a bug where the "last" behaviors icon is used and we attempt to return to the previous page active
            // full testing scenario in the Jira tkt
            localForce = true;
        }

        // 2. Identify. Assumes DOM element holds pageID in value of attribute 'data-page'
        let pageId = $(constants.ID_SEL + clickedId).attr('data-page');
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        // Run the operation on next browser turn to let spinner render
        window.setTimeout(() => {
            // 3. Clear selection on all thumbnails
            $('.page-selected').removeClass('page-selected');
            $(`${constants.CLASS_SEL}${'tn-target'}`).removeClass('page-selected');

            // 3.1 if the event comes from behaviors->layout views, we need to grab the element
            if (listService.currentForm.model.get('restorePageClicked')) {
                selectedElement = $(`#tn-pg-${listService.currentForm.model.get('restorePageClicked')}`)[0].querySelector('div.document-heading');
            }

            // 4. ... but select clicked thumbnail image :-)
            $(selectedElement).addClass('page-selected');
            $( `[data-page='${pageId}']`).parent().addClass('page-selected');

            if(!listService.currentPageId && pageId){
                listService.currentPageId = pageId;
            }

            if (listService.currentPageId !== pageId || force || localForce) {

                if (listService.currentForm.model.get('restorePageClicked')) {
                    pageId = listService.currentForm.model.get('restorePageClicked');
                    listService.currentPageId = pageId;
                    listService.currentForm.model.set('restorePageClicked', null, SILENT);
                }
                // 5. Clear layout DOM, add this page into layout DOM
                if (pageId !== 'aform') {
                    pageSyncService.displayPage(pageId);
                } else {
                    pageSyncService.displayPage(listService.currentPageId);
                }

                // #PF-2353 When a page link is clicked and user is inside behaiors view, it needs to be redirected to edit layout view
                // replicating behavior from flash app
                if (listService.mainKind === constants.KIND_BEHAVIORS || listService.mainKind === constants.KIND_WORKFLOW) {
                    if (pageId !== 'aform') {
                        listService.currentForm.model.set('restorePageClicked', pageId, SILENT);
                    } else {
                        listService.currentForm.model.set('restorePageClicked', listService.currentPageId, SILENT);
                    }

                    // #PF-1951 Turning on flag for back-button purposes
                    listService.linkClicked = true;

                    const loadURL = listService.docType === constants.DOC_TYPE_REPORT ? 'report' : 'edit';

                    Backbone.history.loadUrl(loadURL);
                }

                // 6. Capture the page to a thumbnail
                pageCaptureController.captureThumbnail();

                if (pageId !== 'aform') {
                    eventBus.trigger('selectPage');
                } else {
                    setTimeout(function () {
                        eventBus.trigger('selectForm');
                    }, 100);
                }
            }

            window.setTimeout(() => {
                spinner.stop();
            }, 10);
        }, 10);
    }
   
    addSearchableItem(type, id, name, displayName, instanceId = '', pageName = '', groupName = '') {
        this.searchableItems.push({
            id: id,
            type: type,
            name: name,
            icon: '',
            displayName: displayName,
            instanceId: instanceId,
            pageName,
            groupName
        });
    }

    removeSearchableItem(id) {
        const index = this.searchableItems.findIndex(item => item.id === id);
        this.searchableItems.splice(index, 1);
    }

    addItemToFormCollection(item, collectionType) {
        // object or behaviors
        switch (collectionType) {
            case 'object':
                //this.model.get('formObjects').push(item);
                //this.model.attributes.formObjectCount++;
                break;
            case 'behaviors':
                listService.currentForm.model.get('behaviors').push(item);
                listService.currentForm.model.attributes.behaviorCount++;

                //this.model.get('formBehaviors').push(item);
                //this.model.attributes.formBehaviorCount++;
                break;
        }
    }

    refreshSearchableItems() {
        this.searchableItems = listService.getSearchableItems();
    }

    styleForBadge(i) {
        return i > 0 ? 'inline-block' : 'none';
    }

    openBehaviorsOnly(){
        const page = listService.getPage(listService.currentPageId);

        if(page){
            thumbPageListUtil.updateBehaviorsOnly(page.id);
            leftPanelState.save();    
        }
    }

    //========================================================================================================
    // Populate the thumbnail pane by rendering the collection of thumbnail models.
    // Select current page's thumbnail.
    //========================================================================================================
    render() {

        this.model.set('docType', listService.mainKind === constants.KIND_REPORT ? 'Report' : 'Form', SILENT);

        //this.searchableItems = listService.getSearchableItems();
        const values = thumbPageListUtil.getViewValues(this.model);
        const self = this;
       
        this.$el.empty();
        this.$el.html(template(values));

        //PF-6184 Load behaviors only on demand to avoid performance issues on first load
        // setTimeout(()=>{
        //     $('#behaviorsonly-tab a').off().on('click', (e) => {
        //         self.openBehaviorsOnly(e);
        //        });
        // },100);


        new FilterAndSearchView( {model: this.model, el: '#filterAndSearchPlaceholder', parent: this} ).render();
        new StateAndMandatoryView ( {model: this.model, el: '#stateMandatoryPlaceholder', values: values, parent: this} ).render();
        
        this.initBreadcrumb();

        try {           
            if (listService.firstLoad) {
                this.collection.models.forEach(model => {
                    new ThumbPageView({ model: model, el: constants.THUMBPAGES_ID }).render();
                    new ThumbPageBehaviorsOnlyView({ model: model, el: constants.THUMBPAGESBO_ID, behaviorsOnly: true }).render();
                                       
                });
                leftPanelState.save();
            }
            else {
                leftPanelState.restorePages('#objects-tree');                
                thumbPageListUtil.loadTreeNodesByPageId(listService.currentPageId); //Check if items on tree for current page should be loaded
                thumbPageListUtil.checkBehaviors();
            }

        } catch (err) {
            console.log(`ERROR. ThumbPageView.render issue`, err);
        }

        if ((constants.KIND_LAYOUT + constants.KIND_REPORT).includes(listService.mainKind)) {
            // Ensure current page always selected

            //PF-9437 make sure there is a value in currentPageId if the pages are loaded
            if(!listService.currentPageId){

                if(listService.pageList && listService.pageList.size){
                    const startPage = listService.pageList.first().id;
                    listService.currentPageId = startPage;
                }
            }

            pageSyncService.selectThumbNail(false);
        }

        setTimeout(() => { thumbPageListUtil.addSelectorEvents(); }, 0);

        $('#behaviorsonly-tab').on('click', (ev) => {

            //Do not count Form behaviors 
            //PF-9437 Don't count workflow paths behaviors
            const filteredInstances = listService._behaviorInstanceList.filter(beh=>{
                return beh.get('ownerId') !== 'Form' && beh.get('pageId') && beh.get('pageId') !== "";
            });
            const instances = listService._behaviorObjMap.filter((instance)=>{ return filteredInstances.has(instance.behaviorInstanceId); });
          
            if(!instances.size){
                ev.preventDefault();
                notificationService.info("Please add behaviors before using the Behaviors Only tab.");
                return false;
            }  
            else{
                thumbPageListUtil.updateBehaviorsOnly();
            }          
                
        });

        $(".notDraggablePage").on("dragstart", (ev) => {
            ev.preventDefault;
            notificationService.info('Please select the “All Objects” tab in the navigation panel to re-order pages.');
        });

        $("#thumb-pages").sortable({
            connectWith: "#dropBag",
            containment: ".left-rail-content",
            placeholder: 'slide-placeholder',
            axis: "y",
            forceHelperSize:true,
            forcePlaceholderSize: true,
            scroll: true,
            distance: 10,
            'ui-floating': true,
            start: function (event, ui) {
                ui.placeholder.height(32);
                ui.item.data('start_pos', ui.item.index());
            },
            stop: function (event, ui) {

               // $('#thumb-pages .document-body').css('display', '');
                const start_pos = ui.item.data('start_pos');

                if (start_pos !== ui.item.index()) {                 
                    listService.reorderPages(start_pos, ui.item.index());                   
                }
            }
        });

        this.delegateEvents();
        // PF-2613 -- cause conditional scrollbar if thumbnail item list height exceeds vertical viewport
        $(window).trigger('resize');
        util.doPanelResizable();
        
        return this;
    }

    // PF-5491 method to update page name in navigation tab
    updatePageName(item, newName){

        const changePageName = ($el) => {
            const divPage = $el.find('[data-page=' + item + ']');

            if (divPage && divPage.length) {
                const buttonPage = divPage.find('a');

                divPage.attr('title', newName);
                buttonPage.text(newName);
            }
        }

       changePageName($("#tn-pg-" + item)); //All items
       changePageName($("#bo-pg-" + item)); //Behavior only       
       leftPanelState.save(); 
    }
}

export default ThumbPageListView;
